export default __webpack_public_path__ + "static/media/square728.3e6277cd.png";